var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRtlVersion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 168,
    viewBox: "0 0 300 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_928_2525)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 168,
    rx: 20,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 196,
    rx: 2,
    transform: "matrix(-1 0 0 1 315 -14)",
    fill: "#CBE6C2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 242,
    height: 83,
    rx: 2,
    transform: "matrix(-1 0 0 1 253 76)",
    fill: "#CBE6C2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 71,
    width: 77,
    height: 45,
    rx: 2,
    transform: "rotate(-180 88 71)",
    fill: "#CBE6C2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 71,
    width: 76,
    height: 45,
    rx: 2,
    transform: "rotate(-180 170 71)",
    fill: "#CBE6C2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 71,
    width: 77,
    height: 45,
    rx: 2,
    transform: "rotate(-180 253 71)",
    fill: "#CBE6C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.158 107.828h9.015c1.848 0 3.436.277 4.765.83 1.339.554 2.368 1.373 3.087 2.457.72 1.085 1.079 2.419 1.079 4.001 0 1.295-.221 2.407-.664 3.337a6.24 6.24 0 01-1.842 2.308c-.786.608-1.71 1.095-2.773 1.461l-1.577.83h-7.836l-.033-3.885h5.827c.874 0 1.599-.155 2.175-.465a3.048 3.048 0 001.295-1.295c.299-.553.448-1.195.448-1.926 0-.774-.144-1.444-.432-2.008a2.909 2.909 0 00-1.311-1.295c-.587-.299-1.323-.449-2.208-.449h-4.034V132h-4.981v-24.172zM118.672 132l-5.512-10.774 5.263-.034 5.578 10.576V132h-5.329zm19.439-24.172V132h-4.964v-24.172h4.964zm7.437 0v3.901h-19.722v-3.901h19.722zm19.738 20.287V132h-12.169v-3.885h12.169zm-10.558-20.287V132h-4.981v-24.172h4.981z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 242,
    height: 11,
    rx: 2,
    transform: "matrix(-1 0 0 1 253 9)",
    fill: "#CBE6C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_928_2525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 168,
    rx: 20,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtlVersion);
export default __webpack_public_path__ + "static/media/rtl_version.63b897f2fc6dbf4fd2d8e5dddbce9a85.svg";
export { ForwardRef as ReactComponent };